// ═══════════════════════════════════════════════════════════════
// frontend/src/pages/SaleOrderForm.tsx
// ═══════════════════════════════════════════════════════════════

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SaleApi, PartnerApi } from "../lib/api";
import { useQuery } from "@tanstack/react-query";

export default function SaleOrderForm() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: partners } = useQuery({ queryKey: ["partners"], queryFn: () => PartnerApi.list() });

  const [form, setForm] = useState({ name: "", partnerId: "" });

  const mutation = useMutation({
    mutationFn: () => SaleApi.create({ name: form.name, partnerId: parseInt(form.partnerId) }),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["orders"] }); navigate("/orders"); },
  });

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-6">New Sales Order</h1>
      <form onSubmit={(e) => { e.preventDefault(); mutation.mutate(); }} className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Order Number *</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Customer *</label>
          <select value={form.partnerId} onChange={(e) => setForm({ ...form, partnerId: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" required>
            <option value="">Select a partner...</option>
            {partners?.map((p: any) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        <div className="flex gap-3 pt-2">
          <button type="submit" disabled={mutation.isPending}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {mutation.isPending ? "Saving..." : "Create Order"}
          </button>
          <button type="button" onClick={() => navigate("/orders")}
            className="px-6 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
        </div>
      </form>
    </div>
  );
}
